"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.HiddenInput = exports.Value = exports.CopyInput = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _input = _interopRequireDefault(require("@paprika/input"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CopyInput = _styledComponents["default"].div.withConfig({
  displayName: "CopyInputstyles__CopyInput",
  componentId: "sc-1cc6i5x-0"
})(function (_ref) {
  var hasDefaultButtonBorder = _ref.hasDefaultButtonBorder;
  return (0, _styledComponents.css)(["display:flex;input[data-pka-anchor=\"input\"]{border-radius:", " 0 0 ", ";}[data-pka-anchor=\"button\"]{", "}"], _tokens["default"].border.radius, _tokens["default"].border.radius, !hasDefaultButtonBorder && "border-radius: 0 ".concat(_tokens["default"].border.radius, " ").concat(_tokens["default"].border.radius, " 0;"));
});

exports.CopyInput = CopyInput;

var Value = _styledComponents["default"].div.withConfig({
  displayName: "CopyInputstyles__Value",
  componentId: "sc-1cc6i5x-1"
})(["margin:auto ", " auto 0;"], _tokens["default"].spaceSm);

exports.Value = Value;
var HiddenInput = (0, _styledComponents["default"])(_input["default"]).withConfig({
  displayName: "CopyInputstyles__HiddenInput",
  componentId: "sc-1cc6i5x-2"
})(["&[data-pka-anchor=\"input\"]{display:none;}"]);
exports.HiddenInput = HiddenInput;
//# sourceMappingURL=CopyInput.styles.js.map